<template>
  <div>
    <service-treeview
      :route-type="'URL'"
      :is-policing="true"
      :is-creating-profiling="true"
    />
  </div>
</template>

<script>
export default {
  components: {
    ServiceTreeview: () => import('@/components/services/ServiceTreeview')
  },
  props: {
    service: {
      type: Object,
      default: null
    }
  }
};
</script>
